import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useSignInWithApple from './hooks/useSignInWithApple';

interface Params {
    code: string;
}

const SignInWithAppleActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { code } = params;
  useSignInWithApple(code);
  return (
      <AppScreen>
          <Loading/>
      </AppScreen>
  );
};

export default SignInWithAppleActivity;
